// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { ReactComponent as NotFoundIcon }  from 'common/assets/icons/404.svg';

export const NotFoundSvg = styled(NotFoundIcon)`
   width: 120px;
   fill: ${props => props.theme.primary_color};
`;